export default "https://cdn.questicon.mathletics.com/assets/audio/allStarSpin-6a7f9d24918733f644e3c00b0b43787b.mp3";